var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.5C28.0228 27.5 32.5 23.0228 32.5 17.5C32.5 11.9772 28.0228 7.5 22.5 7.5C16.9772 7.5 12.5 11.9772 12.5 17.5C12.5 23.0228 16.9772 27.5 22.5 27.5Z",
    stroke: "#1DB954",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 52.5V47.5C7.5 44.8478 8.55357 42.3043 10.4289 40.4289C12.3043 38.5536 14.8478 37.5 17.5 37.5H27.5C30.1522 37.5 32.6957 38.5536 34.5711 40.4289C36.4464 42.3043 37.5 44.8478 37.5 47.5V52.5",
    stroke: "#1DB954",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 7.8252C42.151 8.37595 44.0576 9.62695 45.4191 11.381C46.7806 13.135 47.5196 15.2923 47.5196 17.5127C47.5196 19.7331 46.7806 21.8904 45.4191 23.6444C44.0576 25.3984 42.151 26.6494 40 27.2002",
    stroke: "#1DB954",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 52.5V47.5C52.4873 45.2929 51.7448 43.152 50.3882 41.411C49.0316 39.67 47.1371 38.4267 45 37.875",
    stroke: "#1DB954",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.c44cd9da7cb69572c138e8154edb5400.svg";
export { ForwardRef as ReactComponent };